/* eslint-disable @typescript-eslint/no-explicit-any */
import { GeometryEffects } from './geometry.effects';
import { UserEffects } from './user.effects';

export const effectsArray: any[] = [UserEffects, GeometryEffects];
